// Getters
export const RULE_TYPES = 'workingHoursRules/RULE_TYPES'
export const RULES = 'workingHoursRules/RULES'
export const RULES_BY_GROUP = 'workingHoursRules/RULES_BY_GROUP'
export const SEARCH_RESULTS = 'workingHoursRules/SEARCH_RESULTS'
export const RULE_VIOLATION = 'workingHoursRules/RULE_VIOLATION'

// Mutations
export const MUTATE_RULE_TYPES = 'workingHoursRules/MUTATE_RULE_TYPES'
export const MUTATE_RULES = 'workingHoursRules/MUTATE_RULES'
export const MUTATE_RULES_BY_GROUP = 'workingHoursRules/MUTATE_RULES_BY_GROUP'
export const MUTATE_SEARCH_RESULTS = 'workingHoursRules/MUTATE_SEARCH_RESULTS'
export const SET_RULE_VIOLATION = 'SET_RULE_VIOLATION'

// Actions
export const GET_RULE_TYPES = 'GET_RULE_TYPES';
export const SAVE_RULE = 'SAVE_RULE';
export const SEARCH_RULES = 'SEARCH_RULES';
export const DELETE_RULE = 'DELETE_RULE';
export const GET_RULE_BY_ID = 'GET_RULE_BY_ID';
export const GET_RULES_BY_GROUP_ID = 'GET_RULES_BY_GROUP_ID';
export const INIT_RULE_TYPES = 'INIT_RULE_TYPES';
export const CHECK_RULE_VIOLATION = 'CHECK_RULE_VIOLATION'
export const VALIDATE_RULES_BATCH = 'VALIDATE_RULES_BATCH'
export const DISPATCH_DUTIES = 'DISPATCH_DUTIES'
